import { render, staticRenderFns } from "./block-partner-registration-confirm.vue?vue&type=template&id=d066958a&scoped=true&lang=pug&"
import script from "./block-partner-registration-confirm.vue?vue&type=script&lang=js&"
export * from "./block-partner-registration-confirm.vue?vue&type=script&lang=js&"
import style0 from "./block-partner-registration-confirm.vue?vue&type=style&index=0&id=d066958a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d066958a",
  null
  
)

export default component.exports